import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueTheMask from 'vue-the-mask';

import App from '@/App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  });
}

Vue.use(VeeValidate);
Vue.use(VueTheMask);


new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app');
